import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

import { getSharesTransferLabels } from 'modules/transactions/utils/getSharesTransferLabels';
import { isShareClassVisible } from 'modules/trading/utils/isShareClassVisible';

import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';
import ExpandButton from '../ExpandButton';

const SharesTransferTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHistoryMovementsView();

  const modalLabels = getSharesTransferLabels(data?.operationType || '');

  const columns = [
    {
      key: 'transmittingPartner',
      content: t(modalLabels.transmittingPartner),
      textPosition: 'left',
    },
    {
      key: 'recipientPartner',
      content: t(modalLabels.recipientPartner),
      textPosition: 'left',
    },
    isShareClassVisible()
      ? { key: 'class', content: t('Class'), textPosition: 'center' }
      : null,
    { key: 'price', content: t('Price'), textPosition: 'right' },
    { key: 'from', content: t('From'), textPosition: 'right' },
    { key: 'to', content: t('To'), textPosition: 'right' },
    {
      key: 'action',
      content: (
        <ExpandButton
          onClick={actions.handleChangeExpandView}
          expandDirection={data.expandDirection}
        />
      ),
      textPosition: 'right',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default SharesTransferTableHeader;
